import type {FC} from 'react';
import {useAttentionCounts} from '../../../../core/usecases/useAttentionCounts';
import {GeneralHeaderPresentation} from './presentation';

type Props = {
  className?: string;
};

export const GeneralHeaderContainer: FC<Props> = ({className}) => {
  const {scoutsCount, interestsCount, todayDeadlineRecruitmentCount} =
    useAttentionCounts();

  return (
    <GeneralHeaderPresentation
      className={className}
      scoutsCount={scoutsCount}
      interestsCount={interestsCount}
      todayDeadlineRecruitmentCount={todayDeadlineRecruitmentCount}
    />
  );
};
